const totalDuration = 5; // * 60 * 60 = 5 hours
const emittersLifeCount = totalDuration / 0.5;

export const CONFETTI_OPTIONS = {
  "fullScreen": {
    "zIndex": 1
  },
  "particles": {
    number: {
      value: 0
    },
    color: {
      value: [
        "#00FFFC",
        "#FC00FF",
        "#fffc00"
      ]
    },
    "shape": {
      "type": [
        "circle",
        "square",
        "triangle",
        "polygon",
        "character"
      ],
      "options": {
        "polygon": [
          {
            "sides": 5
          },
          {
            "sides": 6
          }
        ],
        "character": {
          "fill": true,
          "font": "Verdana",
          "style": "",
          "weight": 400,
          "particles": {
            "size": {
              "value": 8
            }
          },
          "value": [
            "💩",
            "🤡",
            "🍀",
            "🍙",
            "🦄",
            "⭐️"
          ]
        }
      }
    },
    "opacity": {
      "value": 1,
      "animation": {
        "enable": true,
        "minimumValue": 0,
        "speed": 5,
        "startValue": "max",
        "destroy": "min"
      }
    },
    size: {
      value: 7,
      "random": {
        "enable": true,
        "minimumValue": 2
      }
    },
    links: {
      enable: false
    },
    life: {
      count: 1
    },
    move: {
      enable: true,
      gravity: {
        enable: true,
        acceleration: 10
      },
      speed: {
        min: 10,
        max: 30
      },
      // "decay": 0.1,
      direction: "top",
      straight: false,
      outModes: {
        default: "destroy",
        top: "none"
      }
    },
    "rotate": {
      "value": {
        "min": 0,
        "max": 360
      },
      "direction": "random",
      "move": true,
      "animation": {
        "enable": true,
        "speed": 60
      }
    },
    "tilt": {
      "direction": "random",
      "enable": true,
      "move": true,
      "value": {
        "min": 0,
        "max": 360
      },
      "animation": {
        "enable": true,
        "speed": 60
      }
    },
    "roll": {
      "darken": {
        "enable": true,
        "value": 25
      },
      "enable": true,
      "speed": {
        "min": 15,
        "max": 25
      }
    },
    "wobble": {
      "distance": 30,
      "enable": true,
      "move": true,
      "speed": {
        "min": -15,
        "max": 15
      }
    }
  },
  emitters: {
    life: {
      count: emittersLifeCount,
      duration: 0.1,
      delay: 0.4
    },
    rate: {
      delay: 0.1,
      quantity: 200
    },
    size: {
      width: 0,
      height: 0
    }
  }
}

export const HEART_OPTIONS = {
  background: {
    color: {
      value: 'transparent',
    }
  },
  particles: {
    number: {
      value: 0
    },
    color: {
      value: [
        "#FFC0CB",
        "#FF69B4",
        "#FF1493",
        "#C71585"
      ]
    },
    shape: {
      type: "heart"
    },
    opacity: {
      value: 1
    },
    size: {
      value: { min: 4, max: 10 },
      random: {
        enable: true,
        minimumValue: 4
      }
    },
    links: {
      enable: false
    },
    life: {
      count: 1
    },
    move: {
      enable: true,
      gravity: {
        enable: true,
        acceleration: 10
      },
      speed: 50,
      decay: {
        min: 0.05,
        max: 0.15
      },
      straight: false,
      outModes: {
        default: "destroy",
        top: "none"
      }
    },
    rotate: {
      value: {
        min: 0,
        max: 360
      },
      direction: "random",
      move: true,
      animation: {
        enable: true,
        speed: 60
      }
    },
    tilt: {
      direction: "random",
      enable: true,
      move: true,
      value: {
        min: 0,
        max: 360
      },
      animation: {
        enable: true,
        speed: 60
      }
    },
    roll: {
      darken: {
        enable: true,
        value: 30
      },
      enlighten: {
        enable: true,
        value: 30
      },
      enable: true,
      mode: "horizontal",
      speed: {
        min: 10,
        max: 20
      }
    },
    wobble: {
      distance: 30,
      enable: true,
      move: true,
      speed: {
        min: -15,
        max: 15
      }
    }
  },
  emitters: {
    life: {
      count: emittersLifeCount,
      duration: 0.1,
      delay: 0.4
    },
    rate: {
      delay: 0.1,
      quantity: 100
    },
    size: {
      width: 0,
      height: 0
    }
  }
};

export const FIREWORKS_OPTIONS = {
  name: "Fireworks",
  fullScreen: {
    enable: true,
  },
  background: {
    // color: '#000',
    color: "transparent",
  },
  emitters: {
    direction: "top",
    life: {
      count: emittersLifeCount,
      duration: 0.1,
      delay: 0.1,
    },
    rate: {
      delay: 0.15,
      quantity: 1,
    },
    size: {
      width: 100,
      height: 0,
    },
    position: {
      y: 100,
      x: 50,
    },
  },
  particles: {
    number: {
        value: 0,
    },
    destroy: {
      bounds: {
          top: 30,
      },
      mode: "split",
      split: {
        count: 1,
        factor: {
          value: 0.333333,
        },
        rate: {
          value: 100,
        },
        particles: {
          stroke: {
            width: 0,
          },
          color: {
            value: ["#ff595e", "#ffca3a", "#8ac926", "#1982c4", "#6a4c93"],
          },
          number: {
            value: 0,
          },
          collisions: {
            enable: false,
          },
          destroy: {
            bounds: {
              top: 0,
            },
          },
          opacity: {
            value: {
              min: 0.1,
              max: 1,
            },
            animation: {
              enable: true,
              speed: 0.7,
              sync: false,
              startValue: "max",
              destroy: "min",
            },
          },
          shape: {
              type: "circle",
          },
          size: {
            value: 2,
            animation: {
              enable: false,
            },
          },
          life: {
            count: 1,
            duration: {
              value: {
                min: 1,
                max: 2,
              },
            },
          },
          move: {
            enable: true,
            gravity: {
              enable: true,
              acceleration: 9.81,
              inverse: false,
            },
            decay: 0.1,
            speed: {
              min: 10,
              max: 25,
            },
            direction: "outside",
            outModes: "destroy",
          },
        },
      },
    },
    life: {
        count: 1,
    },
    shape: {
        type: "line",
    },
    size: {
      value: {
        min: 0.1,
        max: 50,
      },
      animation: {
        enable: true,
        sync: true,
        speed: 90,
        startValue: "max",
        destroy: "min",
      },
    },
    stroke: {
      color: {
        value: "#ffffff",
      },
      width: 1,
    },
    rotate: {
      path: true,
    },
    move: {
      enable: true,
      gravity: {
        acceleration: 15,
        enable: true,
        inverse: true,
        maxSpeed: 100,
      },
      speed: {
        min: 10,
        max: 20,
      },
      outModes: {
        default: "destroy",
        top: "none",
      },
      trail: {
        // fill: { color: "#000" },
        fill: { color: "transparent" },
        enable: true,
        length: 10,
      },
    },
  },
  sounds: {
    enable: true,
    events: [
      {
        event: "particleRemoved",
        filter: "explodeSoundCheck",
        audio: [
          "https://particles.js.org/audio/explosion0.mp3",
          "https://particles.js.org/audio/explosion1.mp3",
          "https://particles.js.org/audio/explosion2.mp3",
        ],
      },
    ],
    volume: 50,
  },
};
